import { createContext } from 'react';

import { USER_REPRESENTATIVE } from 'modules/Inquiry/Form/formFields';

export const LegalRepresentativesContext = createContext({
  fieldName: `${USER_REPRESENTATIVE}[0]`,
  userIndex: 0,
});
